import { Injectable } from "@angular/core";
import {
  BULK_SIGNER_TEMPLATE_HEADERS,
  SIGNER_ALLOWED_ACTIONS_EXCEL_LABELS,
} from "@modals/app.modal";

const SIGNERS_SHEET = "Signers";

@Injectable({ providedIn: "root" })
export class BulkSignerTemplateService {
  async buildTemplateBlob(): Promise<Blob> {
    const ExcelJS = (await import("exceljs")).default;
    const workbook = new ExcelJS.Workbook();

    const sheet = workbook.addWorksheet(SIGNERS_SHEET);
    sheet.addRow([...BULK_SIGNER_TEMPLATE_HEADERS]);
    sheet.getRow(1).font = { bold: true };
    sheet.addRow([
      "Jane Doe",
      "signer1@example.com",
      "",
      "+1 555 0100",
      SIGNER_ALLOWED_ACTIONS_EXCEL_LABELS.All,
    ]);
    sheet.addRow([
      "Sam Signer",
      "signer2@example.com",
      "cc@example.com",
      "",
      `${SIGNER_ALLOWED_ACTIONS_EXCEL_LABELS.SIGNATURE}, ${SIGNER_ALLOWED_ACTIONS_EXCEL_LABELS.DATE}, ${SIGNER_ALLOWED_ACTIONS_EXCEL_LABELS.TEXT}`,
    ]);

    sheet.columns = [
      { width: 20 },
      { width: 28 },
      { width: 22 },
      { width: 16 },
      { width: 38 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    return new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
  }
}
